<template>
    <div class="grey-600" v-show="hasNote() && !shouldShowInput">
        <b>Notes:</b> {{ entry.notes }}
    </div>
    <button v-show="!shouldShowInput" class="btn btn-link pl-0 grey-600" @click="showEditor">
        <span v-show="!hasNote()"><i class="fa fa-plus-circle mr-5"></i> Add</span>
        <span v-show="hasNote()"><i class="fa fa-pencil mr-5"></i> Edit</span>
        Notes
    </button>
    <div v-show="shouldShowInput">
        <Notes ref="notes"
               :entry="entry"
               :error="error"
               :hide-editor="hideEditor"/>
    </div>
</template>

<script>
import Notes from "./Notes";
import {ref} from "vue";

export default {
    components: {
        Notes,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
    },
    setup() {
        return {
            shouldShowInput: ref(false)
        }
    },
    methods: {
        hasNote() {
            return this.entry.notes && this.entry.notes.trim() !== ''
        },
        showEditor() {
            this.shouldShowInput = true
            this.$nextTick(() => this.$refs.notes.focus())
        },
        hideEditor() {
            this.shouldShowInput = false
        },
    },
}
</script>

<style scoped>

</style>
